import React from 'react';

class RowItemSLKKXMTS extends React.Component {

  render() {
    let Item = this.props.item;
    let data = Item ? Item.soLieuBaoCaoInfo : {};
    return (
      <tr className={this.props.sum ? 'txt-bold' : ''}>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='column-name-fixed'>{data.tenDonVi}</td>

        <td className='txt-center'>{data.soNguoiPhaiKeKhaiTrongNam}</td>
        <td className='txt-center'>{data.soNguoiDaKeKhai}</td>
        <td className='txt-center'>{data.soNguoiCongKhaiTheoHTNiemYet}</td>
        <td className='txt-center'>{data.soNguoiCongKhaiTheoHTTCHoiHop}</td>
        <td className='txt-center'>{data.soNguoiDuocXMTSThuNhap}</td>
        <td className='txt-center'>{data.soNguoiDaCoKLVVKKHTSTNKhongTrungThuc}</td>
        <td className='txt-center'>{data.soNguoiDaBiXLKLDoKKHTSTNKhongTrungThuc}</td>
        <td className='txt-center'>{data.soNguoiDaBiXLKLDoChamTCKKHTHBCKQMBTaiSan}</td>
        <td className='txt-center'>{data.soNguoiDaBiXLTNTrongXacMinhTaiSanThuNhap}</td>
        <td className='ghi-chu'>{data.ghiChu}</td>
      </tr>
    );
  }
}

export default RowItemSLKKXMTS;


// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-tong-hop/datatable/RowItemSLKKXMTS.jsx